import { NgModule } from '@angular/core';
import { AppButtonModule } from 'src/app/components/button/button.module';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/** Layout files */
import { AuthLayout } from './auth.layout';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

/** Pipes */
import { UserPrefixPipeModule } from '../../pipes/user-prefix/user-prefix.pipe.module';
import { RelativeTimePipeModule } from 'src/app/pipes/relative-time/relative-time.pipe.module';
import { SpinnerComponent } from 'src/app/components/spinner/spinner.component';
import { KebabCasePipeModule } from 'src/app/pipes/kebab-case/kebab-case.pipe.module';
import { SelectedUserRolesToRolePipeModule } from 'src/app/pipes/selected-user-roles-to-role/selected-user-roles-to-role.pipe.module';
import { UserRolesToRolePipeModule } from 'src/app/pipes/user-roles-to-role/user-roles-to-role.pipe.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MdAiPanelComponent } from '../../components/md-ai-panel/md-ai-panel.component';

@NgModule({
  declarations: [
    AuthLayout
  ],
  imports: [
    AppButtonModule,
    CommonModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    RelativeTimePipeModule,
    FormsModule,
    UserPrefixPipeModule,
    SpinnerComponent,
    KebabCasePipeModule,
    UserRolesToRolePipeModule,
    SelectedUserRolesToRolePipeModule,
    NgSelectModule,
    ModalModule.forRoot(),
    MdAiPanelComponent,
  ]
})

export class AuthLayoutModule { }
